<template>
    <div>
    <h5 class="sa-card-tit">Select Radiology</h5>
    <div class="sa-row">
      <div class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4"> 
      <ul class="sa-unorder-list" >
        <li v-for="(val, i) in values" :key="i">{{val.tsk_nm}}</li>
      </ul>
      </div>
    </div>
    <div class="sa-mt40 sa-text-right ">
            <button class="sa-btn sa-btn-large sa-btn-primary " @click="referRadiology()">Continue</button>
        </div>
    </div>
</template>
<script>
import { pro_url } from "../../../../../config/endpoints";
export default {
  props: [ 'selected', 'masterData' ],
    data(){
        return{
            values:[]
        }
    },
    mounted () {
    },
    watch: {
      selected: {
        immediate: true,
        deep: true,
        handler (val) {
          this.remindselection(val)
        }
      }
    },
    methods:{
      remindselection(val){
        let Data = this.masterData
        let Obj = []
         for (let i = 0; i < Data.length; i++) {
            for(let x = 0; x < val.length; x++){
              if(Data[i].tsk_id === val[x]){
                Obj.push(Data[i])
              }
            }
          }
          this.values = Obj
      },
      referRadiology () {
        this.loading = true
        let _self = this
        _self.patDetails = JSON.parse(_self.$localStorage.get('patDetails'))
        _self.$store.dispatch('httpPost', {
            uri: `${pro_url}/refer/addTreatmentReferal`,
            body:{
            "apnt_id": _self.patDetails.apnt_id,
            // "pid": _self.patDetails.pid,
            "uid": _self.patDetails.refDoctor || "",
            stid: _self.patDetails.stid || '',
            dept_id: _self.patDetails.dept_id || '',
            "pkg_id": _self.patDetails.refPackages || [],
            "tsk_id": _self.patDetails.refNurse,
            "tst_id": _self.patDetails.refTests || [],
            "trtmnt_id": _self.patDetails.refPhysio || [],
            "hemodialysis": _self.patDetails.hemodialysis || [],
            "covid": _self.patDetails.covid || [],
            "vitamin_iv_drip": _self.patDetails.vitamin_iv_drip || [],
            "vaccination": _self.patDetails.vaccination || [],
            'radiology':  _self.selected,
            ref_doctorId : _self.patDetails.ref_doctorId || ''
            }
        }).then(response => {

            _self.loading = false
            if (response && response.status === 1000) {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
                msg: "Referred Radiology Tasks successfully",
                class: "sa-a-success"
            });
            this.$emit('close')
            } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
                msg: `${response.desc}. Something went wrong. Please try again or contact operations team`,
                class: "sa-a-danger"
            });
            }
        })      
    }
    }
}
</script>